<template>
  <div ref="map" class="h-full w-full map-container"></div> 
</template>

<script>
export default {
  props: {
    apiKey: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      map: null,
      marker: null
    }
  },
  mounted() {    
    this.loadGoogleMapsScript()
      .then(() => {
        this.initMap()
      })
      .catch((error) => {
        console.error('Google Maps script could not be loaded:', error)
      })
  },
  created () {
    this.$bus.$on('insertedZipcode', (zipcode) => {
      setTimeout(() => {
        this.updateMarkerPosition(zipcode)
      }, 500)
    })
  },
  beforeDestroy() {
    this.$bus.$off('insertedZipcode')
  },
  methods: {
    loadGoogleMapsScript() {
      return new Promise((resolve, reject) => {
        if (typeof google !== 'undefined') {
          resolve()
          return
        }
        
        // Check if the script is already loading
        if (document.getElementById('google-maps-script')) {
          document.getElementById('google-maps-script').addEventListener('load', resolve)
          document.getElementById('google-maps-script').addEventListener('error', reject)
          return
        }

        const script = document.createElement('script')
        script.id = 'google-maps-script'
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=initMap`
        script.async = true
        script.defer = true
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },
    initMap() {
      // eslint-disable-next-line no-undef
      this.map = new google.maps.Map(this.$refs.map, {
        center: { lat: 34.4130, lng: -119.7001 }, // Coordinates for the default address "510 Castillo St, Santa Barbara, CA 93101, USA"
        zoom: 14,
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false
      })
      
      // eslint-disable-next-line no-undef
      this.marker = new google.maps.Marker({
        position: { lat: 34.4130, lng: -119.7001 },
        map: this.map,
        title: 'Container Alliance'
      })

      this.map.addListener('click', () => {
        window.open('https://maps.app.goo.gl/1d2CLgnD8pDDd1EVA', '_blank')
      })
    },
    updateMarkerPosition(zipcode) {
      // Geocode the zipcode to get latitude and longitude
      // eslint-disable-next-line no-undef
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({ address: zipcode }, (results, status) => {
        if (status === 'OK') {
          const location = results[0].geometry.location
          this.map.setCenter(location)
          this.marker.setPosition(location)
        } else {
          console.error('Geocode was not successful for the following reason:', status)
        }
      })
    }
  }
}
</script>
